// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

sf-data-panel {
  background-color: #eee;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: 100%;
  border: solid black 1px;
  border-radius: 5px;
  /* do not allow child elements to overlap rounded corners */
  overflow: hidden;
}

.tabs {
  background-color: #eee;
  flex: 0 0 2em;
  display: flex;
}

.tab-link {
  background-color: inherit;
  border: none;
  cursor: pointer;
  line-height: 2em;
  background-color: #eee;
  font-size: 1em;
  font-family: sans-serif;
  padding: 0 0.5em 0 0.5em;
  outline-offset: -0.2em;
  min-width: 5em;
  border-radius: 5px 5px 0 0;
}

.tab-link:hover {
  background-color: #ddd;
}

.tab-link.active {
  background-color: #fff;
}

.tab-link.populated {
  font-weight: bold;
}

.tab-content {
  display: none;
  flex: 0 0 calc(100% - 2em);
  overflow: auto;
}

.tab-content.active {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/data/DataPanel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\nsf-data-panel {\n  background-color: #eee;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  height: 100%;\n  border: solid black 1px;\n  border-radius: 5px;\n  /* do not allow child elements to overlap rounded corners */\n  overflow: hidden;\n}\n\n.tabs {\n  background-color: #eee;\n  flex: 0 0 2em;\n  display: flex;\n}\n\n.tab-link {\n  background-color: inherit;\n  border: none;\n  cursor: pointer;\n  line-height: 2em;\n  background-color: #eee;\n  font-size: 1em;\n  font-family: sans-serif;\n  padding: 0 0.5em 0 0.5em;\n  outline-offset: -0.2em;\n  min-width: 5em;\n  border-radius: 5px 5px 0 0;\n}\n\n.tab-link:hover {\n  background-color: #ddd;\n}\n\n.tab-link.active {\n  background-color: #fff;\n}\n\n.tab-link.populated {\n  font-weight: bold;\n}\n\n.tab-content {\n  display: none;\n  flex: 0 0 calc(100% - 2em);\n  overflow: auto;\n}\n\n.tab-content.active {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
